import { Link } from "@simplybusiness/mobius";
import { TrustBanner } from "../TrustBanner/TrustBanner";
import { TrustBannerImages } from "../TrustBanner/TrustBannerImages";
import { usePreload } from "../../hooks";
import type { InterventionProps } from "../../types";

const TRUSTPILOT_REVIEW_URL =
  "https://uk.trustpilot.com/review/simplybusiness.co.uk";

export const Q2QEmbedTrustpilotBanner = (props: InterventionProps) => {
  usePreload(TrustBannerImages["trustpilot_alternate"].src);
  const { data, fireEvent } = props;
  const componentNames = data?.component_names;

  if (!componentNames || componentNames.length === 0) return null;

  // Variant B
  if (componentNames.includes("trust-banner-variant-b")) {
    return <TrustBanner variant="trustpilot_alternate" />;
  }
  // Variant C
  if (componentNames.includes("trust-banner-variant-c")) {
    const handleClick = () => {
      fireEvent?.("clicked_trust_banner_variant_c");
    };

    return (
      <Link
        href={TRUSTPILOT_REVIEW_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="View Simply Business reviews on Trustpilot in a new tab"
        onClick={handleClick}
      >
        <TrustBanner variant="trustpilot_alternate" />
      </Link>
    );
  }
  // Control and fallback
  return null;
};
